export default {
  users: 'کاربران',
  index: 'لیست',
  dashboard: 'داشبورد',
  add: 'افزودن',
  edit: 'ویرایش',
  profile: 'پروفایل',
  changePassword: 'تغییر رمز عبور',
  roles: 'نقش ها',
  coupons: 'کوپن ها',
  payments: 'پرداخت ها',
  realms: 'حوزه ها',
  organizations: 'سازمان ها',
  workingSites: 'سایت های کاری',
  devices: 'دستگاه ها',
  paymentConfigs: 'روش های پرداخت'
}
